module.exports = __webpack_public_path__ + "static/media/call_voip.dbf5074a.png";